(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairSurveyController', VirtualFairSurveyController);

    VirtualFairSurveyController.$inject = ['VirtualFairService', '$uibModal'];

    function VirtualFairSurveyController(VirtualFairService, $uibModal) {
        var vm = this;
        vm.getSurveys       = getSurveys;
        vm.activate         = activate;
        vm.getByFilter      = getByFilter;
        vm.surveySelected   = '';
        vm.flag             = false;

        function activate() {
            vm.getSurveys();
        }

        function getSurveys() {
            VirtualFairService.getSurveys().then(function(response) {
                vm.surveys = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag     = false;
            let query   = {};
            if(vm.surveySelected != '') {
                query['survey'] = vm.surveySelected;
            }
            VirtualFairService.getSurveyQuestions(query).then(function(response) {
                console.log(response);
                vm.response         = response.data;
                vm.flag             = true;
            });
        }
        vm.activate();

    }
})();
